export default "__VITE_ASSET__2a96faa7__"